<app-skeleton-template *ngIf="!loadInfo" [template]="skeletonTemplate"></app-skeleton-template>

<form novalidate [formGroup]="form" *ngIf="loadInfo">
  <div class="tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkAlcohol" class="tw-flex tw-items-center" >
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cerveza-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Bebe alcohol?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('drinkAlcohol').value" formControlName="drinkAlcoholFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántas copas bebe al día?</p>
          <nz-input-number [nzDisabled]="!form.get('drinkAlcohol').value" [nzMin]="0" formControlName="cupAlcoholPerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="smoke" class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-cigar-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Fuma?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('smoke').value" formControlName="smokeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántos cigarros fuma al día?</p>
          <nz-input-number [nzDisabled]="!form.get('smoke').value" [nzMin]="0" formControlName="cigarettesPerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[30, 30]">
      <div nz-col nzXs="24" nzMd="8">
        <label nz-checkbox formControlName="drinkCoffee" class="tw-flex tw-items-center">
          <div class="tw-flex tw-items-center">
            <img src="./../../../assets/images/icons/icons8-coffee-pot-100.png" class="tw-w-8 tw-mr-2" alt="">
            <p class="text-info">¿Toma café?</p>
          </div>
        </label>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <nz-select [nzDisabled]="!form.get('drinkCoffee').value" formControlName="drinkCoffeeFrequency" nzBorderless class="tw-w-full">
          <nz-option *ngFor="let frequency of frequencies" [nzValue]="frequency.value" [nzLabel]="frequency.label"></nz-option>
        </nz-select>
      </div>
      <div nz-col nzXs="24" nzMd="8">
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="text-info tw-mr-2">¿Cuántas tazas toma al día?</p>
          <nz-input-number [nzDisabled]="!form.get('drinkCoffee').value" [nzMin]="0" formControlName="cupCoffeePerDay" style="max-width: 60px;"></nz-input-number>
        </div>
      </div>
    </div>
  </div>

  <div class="tw-mt-5 tw-p-5 tw-rounded-md tw-border tw-border-solid tw-border-gray-100">
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col
           nzXs="24"
           nzMd="24" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Con qué frecuencia te has sentido incapaz de controlar las cosas importantes de tu vida?</div>
        <nz-select formControlName="howOftenHaveFeltUnableToControlImportantThings" nzPlaceHolder="Seleccione la opción">
          <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
      </div>
      <div nz-col
           nzXs="24"
           nzMd="24" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Con qué frecuencia has estado seguro sobre tu capacidad para manejar tus problemas personales?</div>
        <nz-select formControlName="howOftenHaveBeenConfidentAboutAbilityToHandlePersonalProblems" nzPlaceHolder="Seleccione la opción">
          <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
      </div>
      <div nz-col
           nzXs="24"
           nzMd="24" class="mb-sm d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Con qué frecuencia has sentido que las cosas te van bien?</div>
        <nz-select formControlName="howOftenHaveFeltThatThingsAreGoingWell" nzPlaceHolder="Seleccione la opción">
          <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
      </div>
      <div nz-col
           nzXs="24"
           nzMd="24" class="d-flex flex-column justify-content-between">
        <div class="input-label-form">¿Con qué frecuencia has sentido que las dificultades se acumulan tanto que no puedes superarlas?</div>
        <nz-select formControlName="howOftenHaveFeltThatDifficultiesArePilingUpSoMuchThatCanOvercomeThem" nzPlaceHolder="Seleccione la opción">
          <nz-option *ngFor="let option of options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <!--<app-message-field [field]="nutritionalForm.get('nutritionalRegimen')"></app-message-field>-->
      </div>
    </div>
  </div>

</form>
<div class="d-flex justify-content-end" *ngIf="!(this.isPatient$ | async)">
  <button class="mt-xlg" nz-button nzType="primary" (click)="onSave()"><i nz-icon nzType="save" nzTheme="outline"></i>GUARDAR</button>
</div>
